/**
 * 邮箱管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>邮箱管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索"></el-form-item> -->
       <el-form-item label="邮箱状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in emailStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleAdd">添加</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleExport" title="批量导入用户">用户导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="sendAll" title="批量发送通知消息">发送消息</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="username" align="center" label="邮箱地址" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="password" align="center" label="邮箱授权码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="host" align="center" label="邮箱服务器" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="mobile" align="center" label="头像" width="80px" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.pc_head">
        　  <img :src="scope.row.pc_head" width="40" height="40" class="head_pic"/>
        </template>
      </el-table-column> -->
      <el-table-column prop="port" align="center" label="邮箱端口号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="name" align="center" label="发送者名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="邮箱状态" :formatter="statusFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180px">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleInfo(scope.$index, scope.row)" title="查看详情和推广记录">详情</el-button>
          <el-button size="mini" @click="handleSeller(scope.$index, scope.row)" title="将账户设置为商务">商务</el-button> -->
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" title="发送消息通知">编辑</el-button>
          <el-button size="mini" type="danger" @click="delEmail(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-form-item label="邮箱地址" prop="username">
          <el-input size="small" v-model="infoForm.username" auto-complete="off" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="邮箱授权码" prop="password">
          <el-input size="small" v-model="infoForm.password" auto-complete="off" placeholder="请输入邮箱授权码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱服务器" prop="host">
          <el-input size="small" v-model="infoForm.host" auto-complete="off" placeholder="请输入邮箱服务器"></el-input>
        </el-form-item>
        <el-form-item label="邮箱端口号" prop="port">
          <el-input size="small" v-model="infoForm.port" auto-complete="off" placeholder="请输入邮箱端口号"></el-input>
        </el-form-item>
        <el-form-item label="发送者名称" prop="name">
          <el-input size="small" v-model="infoForm.name" auto-complete="off" placeholder="请输入发送者名称"></el-input>
        </el-form-item>
        <el-form-item label="邮箱状态" prop="status">
                <el-radio-group type="kind" v-model="infoForm.status"> 
                    <el-radio v-model="infoForm.status" :label="1">否</el-radio>
                    <el-radio v-model="infoForm.status" :label="2">是</el-radio>
                </el-radio-group>
            </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="confirmEditEmail">提交</el-button>
          <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

     <!-- 上传Excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M<button @click="downloadExcel()" style="margin-left: 15px;cursor: pointer">下载模板</button></div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getEmailList, delEmail, editEmail } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '用户详情',
      infoForm: {
        id: 0,
        username: '',
        password: '',
        host: '',
        port: '',
        name: '',
        status: 0
      },
       formInline: {
        page: 1,
        ps: 10,
        status: 0
      },
      listData: [], //列表数据
      emailStatus: [
        { key: '全部', value: 0 },
        { key: '已启用', value: 2 },
        { key: '未启用', value: 1 }
      ],
    
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      infoFormRules: {
        username: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入邮箱授权码', trigger: 'blur' }
        ],
        host: [
          { required: true, message: '请输入邮箱服务器', trigger: 'blur' }
        ],
        port: [
          { required: true, message: '请输入邮箱端口号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入发送者名称', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择邮箱状态', trigger: 'blur' }
        ]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 查询邮箱列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getEmailList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      // this.formInline.ps = 10,
      this.getdata(this.formInline)
    },
    // 显示添加界面
    handleAdd() {
      this.infoForm.id = 0
      this.infoForm.username = ''
      this.infoForm.password = ''
      this.infoForm.host = ''
      this.infoForm.port = ''
      this.infoForm.name = ''
      this.infoForm.status = ''
      this.title = '添加邮箱'
      this.editFormVisible = true
    },
    // 显示编辑界面
    handleEdit(index, row) {
      this.infoForm.id = row.id
      this.infoForm.username = row.username
      this.infoForm.password = row.password
      this.infoForm.host = row.host
      this.infoForm.port = row.port
      this.infoForm.name = row.name
      this.infoForm.status = row.status
      this.title = '编辑邮箱'
      this.editFormVisible = true
    },
    // 确认提交邮箱编辑
    confirmEditEmail() {
      let sendData = 'infoForm'
      this.$refs[sendData].validate(valid => {
        if(valid){
          let param = this.infoForm
            editEmail(param)
            .then(res => {
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.editFormVisible = false
                this.getdata(this.formInline)
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误!')
            })
        }else{
          return false;
        }
    })
    },
    // 删除邮箱
    delEmail(index, row) {
    this.$confirm('确定要删除邮箱吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          delEmail(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('邮箱删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     // 邮箱状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '未启用'
        }else if(row.status == 2){
            return '已启用'
        }else{
            return '未知'
        }
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'infoForm'){
        this.editFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.invite_item {
  height: 600px;
  overflow-y: auto;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/mail/email.vue